import { ChainConfig, TokenInfo } from '../types';
import ShidoBridgeABI from './ShidoBridge.abi.json';

export const CHAIN_CONFIGS: Record<string, ChainConfig> = {
  'ethereum': {
    name: 'Ethereum',
    chainId: '0x1', // 1
    rpcUrl: 'https://eth-mainnet.g.alchemy.com/v2/BDpaubxVA99CLmap8yzG3b1FCp3EjN4A',
    fallbackRpcUrls: [
      'https://shido-ethereum-mainnet.zeeve.net/QPx9J5vEX55TZXkurgbex3/rpc',
      'https://ethereum-rpc.publicnode.com',
      'https://rpc.ankr.com/eth',
      'https://eth.llamarpc.com'
    ],
    bip44ChainId: 2147483708,
    USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    decimals: 6,
    bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
    icon: '/images/eth.svg',
    explorerUrl: 'https://etherscan.io',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18
    }
  },
  'arbitrum': {
    name: 'Arbitrum One',
    chainId: '0xa4b1', // 42161
    rpcUrl: 'https://arb-mainnet.g.alchemy.com/v2/BDpaubxVA99CLmap8yzG3b1FCp3EjN4A',
    fallbackRpcUrls: [
      'https://shido-arbitrum-mainnet.zeeve.net/f9fQztXTP9VpaiuXJFWZHw/rpc',
      'https://arbitrum-one-rpc.publicnode.com',
      'https://rpc.ankr.com/arbitrum',
      'https://arb1.arbitrum.io/rpc'
    ],
    bip44ChainId: 1073741826,
    USDC: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    decimals: 6,
    bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
    icon: '/images/arb.png',
    explorerUrl: 'https://arbiscan.io',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18
    }
  },
  'avalanche': {
    name: 'Avalanche',
    chainId: '0xa86a', // 43114
    rpcUrl: 'https://avax-mainnet.g.alchemy.com/v2/BDpaubxVA99CLmap8yzG3b1FCp3EjN4A',
    fallbackRpcUrls: [
      'https://shido-avalanche-mainnet.zeeve.net/QJDcthMJ7xexcVExsRxiNK/ext/bc/C/rpc',
      'https://avalanche-c-chain-rpc.publicnode.com',
      'https://rpc.ankr.com/avalanche',
      'https://api.avax.network/ext/bc/C/rpc'
    ],
    bip44ChainId: 2147492648,
    USDC: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
    USDT: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
    decimals: 6,
    bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
    icon: '/images/avax.png',
    explorerUrl: 'https://snowtrace.io',
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18
    }
  },
  'bsc': {
    name: 'BNB Smart Chain',
    chainId: '0x38', // 56
    rpcUrl: 'https://bnb-mainnet.g.alchemy.com/v2/BDpaubxVA99CLmap8yzG3b1FCp3EjN4A',
    fallbackRpcUrls: [
      'https://shido-binance-mainnet.zeeve.net/b5zrbb7uDAWaEcMMH9cRyv/rpc',
      'https://bsc-rpc.publicnode.com',
      'https://rpc.ankr.com/bsc',
      'https://bsc-dataseed1.binance.org'
    ],
    bip44ChainId: 2147484362,
    USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    USDT: "0x55d398326f99059fF775485246999027B3197955",
    decimals: 18,
    bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
    icon: '/images/bnb.png',
    explorerUrl: 'https://bscscan.com',
    nativeCurrency: {
      name: 'Binance Coin',
      symbol: 'BNB',
      decimals: 18
    }
  },
  // 'polygon': {
  //   name: 'Polygon',
  //   chainId: '0x89', // 137
  //   rpcUrl: 'https://polygon-bor-rpc.publicnode.com',
  //   bip44ChainId: 2147484614,
  //   USDC: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
  //   USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
  //   decimals: 6,
  //   bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
  //   icon: '/images/matic.png',
  //   explorerUrl: 'https://polygonscan.com',
  //   nativeCurrency: {
  //     name: 'MATIC',
  //     symbol: 'MATIC',
  //     decimals: 18
  //   }
  // },
  'base': {
    name: 'Base',
    chainId: '0x2105', // 8453
    rpcUrl: 'https://base-mainnet.g.alchemy.com/v2/BDpaubxVA99CLmap8yzG3b1FCp3EjN4A',
    fallbackRpcUrls: [
      'https://base-rpc.publicnode.com',
      'https://rpc.ankr.com/base',
      'https://mainnet.base.org'
    ],
    bip44ChainId: 1073741841,
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    USDT: "0xfde4c96c8593536e31f229ea8f37b2ada2699bb2",
    decimals: 6,
    bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
    icon: '/images/base.png',
    explorerUrl: 'https://basescan.org',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18
    }
  },
  'shido-mainnet': {
    name: 'Shido Network',
    chainId: '0x2330', // 9008
    rpcUrl: 'https://evm.shidoscan.net',
    fallbackRpcUrls: [
      'https://evm.mavnode.io',
      'https://shido-testnet-archive-lb-q1ifr9jpz.zeeve.net/USjg7xqUmCZ4wCsqEOOE/rpc'
    ],
    bip44ChainId: 1073741856,
    USDC: "0xeE1Fc22381e6B6bb5ee3bf6B5ec58DF6F5480dF8",
    USDT: "0x318A0dd4142fDDfffC000c877bE7Ae6679185200",
    decimals: 6,
    bridge: "0x3d64bd587300af85Ae54007D350BfD293dc24581",
    icon: '/images/wshido.png',
    explorerUrl: 'https://shidoscan.net',
    nativeCurrency: {
      name: 'Shido',
      symbol: 'SHIDO',
      decimals: 18
    }
  }
};

export const TOKEN_INFO: Record<string, TokenInfo> = {
  'USDC': {
    symbol: 'USDC',
    name: 'USD Coin',
    icon: '/images/usdc.png',
    decimals: 6
  },
  'USDT': {
    symbol: 'USDT',
    name: 'Tether USD',
    icon: '/images/usdt.png',
    decimals: 6
  }
};

export const ERC20_ABI = [
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' }
    ],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'decimals',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint8' }]
  },
  {
    type: 'function',
    name: 'name',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  },
  {
    type: 'function',
    name: 'symbol',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  }
];

export const BRIDGE_ABI = ShidoBridgeABI;

export const DEFAULT_GAS_LIMIT = 1500000;
export const LOCAL_STORAGE_KEY = 'shido-bridge-transactions';
